import { Table, Form, Col, InputGroup, Card, Row } from "react-bootstrap";
import {
  AFTER_MEAL,
  ALERT_3IN7,
  ALERT_3READINGS,
  ALERT_EVERY,
  CONTEXT,
  FASTING,
  LOWER_BOUND,
  MEASUREMENT,
  SEND_ALERT,
  UPPER_BOUND,
  SYSTOLIC,
  DIASTOLIC,
  BG,
  BP,
  ALERT_MISSING,
  LOW_VALUE,
  NO_VALUES,
} from "../../../util/const";
import { useAlertSettings } from "../../../services/useData";


const AlertSettings = () => {

  const fetchedData = useAlertSettings();
  const settings = fetchedData.settings;

  if(settings !== undefined && settings.length > 0)
  {
    const gdm = settings[0];
    return (
      <Form noValidate >
        <Card className="mt-3">
          <Card.Body>
            <Row className="middle">
              <Col sm={8}>
                <Table bordered hover className="review-table">
                  <thead>
                    <tr>
                      <th className="section">{MEASUREMENT}</th>
                      <th className="section">{CONTEXT}</th>
                      <th className="section">{UPPER_BOUND}</th>
                      <th className="section">{LOWER_BOUND}</th>
                      <th className="section">{SEND_ALERT}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowSpan={4}>{BG}</td>
                      <td className="left">{FASTING}</td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="fasting-upper"
                            value={gdm!.fastingUpper}
                            // onChange={(e) => {
                            //   setFastingUpper(e.target.value);
                            //   context.patient.fastingUpper = e.target.value;
                            // }}
                            disabled
                            //required
                          />
                          <InputGroup.Text id="basic-addon1">mmol/L</InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="fasting-lower"
                            value={gdm!.fastingLower}
                            // onChange={(e) => {
                            //   setFastingLower(e.target.value);
                            //   context.patient.fastingLower = e.target.value;
                            // }}
                            disabled
                            //required
                          />
                          <InputGroup.Text id="basic-addon1">mmol/L</InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <Form.Select
                          id="bgFastingRuleId"
                          value={gdm!.fastingRule}
                          // onChange={(e) => {
                          //   setBgRuleFasting(e.target.value);
                          //   context.patient.fastingRule = e.target.value;
                          // }}
                          disabled>
                          <option value=""></option>
                          <option value={ALERT_EVERY}>{ALERT_EVERY}</option>
                          <option value={ALERT_3READINGS}>{ALERT_3READINGS}</option>
                          <option value={ALERT_MISSING}>{ALERT_MISSING}</option>
                          <option value={ALERT_3IN7}>{ALERT_3IN7}</option>
                        </Form.Select>
                      </td>
                    </tr>
                    <tr>
                      <td className="left">{AFTER_MEAL}</td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="after-upper"
                            value={gdm!.afterMealUpper}
                            // onChange={(e) => {
                            //   setAfterMealUpper(e.target.value);
                            //   context.patient.amUpper = e.target.value;
                            // }}
                            disabled
                            //required
                          />
                          <InputGroup.Text id="basic-addon1">mmol/L</InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="after-lower"
                            value={gdm!.afterMealLower}
                            // onChange={(e) => {
                            //   setAfterMealLower(e.target.value);
                            //   context.patient.amLower = e.target.value;
                            // }}
                            disabled
                            //required
                          />
                          <InputGroup.Text id="basic-addon1">mmol/L</InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <Form.Select
                          id="bgRuleId"
                          value={gdm!.afterMealRule}
                          // onChange={(e) => {
                          //   setBgRule(e.target.value);
                          //   context.patient.amRule = e.target.value;
                          // }}
                          disabled>
                          <option value=""></option>
                          <option value={ALERT_EVERY}>{ALERT_EVERY}</option>
                          <option value={ALERT_3READINGS}>{ALERT_3READINGS}</option>
                          <option value={ALERT_MISSING}>{ALERT_MISSING}</option>
                          <option value={ALERT_3IN7}>{ALERT_3IN7}</option>
                        </Form.Select>
                      </td>
                    </tr>
                    <tr>
                      <td className="left">{LOW_VALUE}</td>
                      <td colSpan={2}></td>
                      <td>
                        {gdm!.lowRule}
                      </td>
                    </tr>
                    <tr>
                      <td className="left">{NO_VALUES}</td>
                      <td colSpan={2}></td>
                      <td>
                        <Form.Select
                          id="bgMissingRuleId"
                          value={gdm!.noDataRule}
                          // onChange={(e) => {
                          //   setBgRuleMissing(e.target.value);
                          //   context.patient.missingRule = e.target.value;
                          // }}
                          disabled>
                          <option value=""></option>
                          <option value={ALERT_EVERY}>{ALERT_EVERY}</option>
                          <option value={ALERT_3READINGS}>{ALERT_3READINGS}</option>
                          <option value={ALERT_MISSING}>{ALERT_MISSING}</option>
                          <option value={ALERT_3IN7}>{ALERT_3IN7}</option>
                        </Form.Select>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan={2}>{BP}</td>
                      <td className="left">{SYSTOLIC}</td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="sys-upper"
                            value={gdm!.sysUpper}
                            // onChange={(e) => {
                            //   setSysUpper(e.target.value);
                            // }}
                            disabled
                          />
                          <InputGroup.Text id="basic-addon1">mmHg </InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="sys-lower"
                            value={gdm!.sysLower}
                            // onChange={(e) => {
                            //   setSysLower(e.target.value);
                            // }}
                            disabled
                            //required
                          />
                          <InputGroup.Text id="basic-addon1">mmHg </InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <Form.Select
                          id="sysRuleId"
                          value={gdm!.sysRule}
                          // onChange={(e) => {
                          //   setSysRule(e.target.value);
                          // }}
                          disabled>
                          <option value=""></option>
                          <option value={ALERT_EVERY}>{ALERT_EVERY}</option>
                          <option value={ALERT_3READINGS}>{ALERT_3READINGS}</option>
                          <option value={ALERT_MISSING}>{ALERT_MISSING}</option>
                          <option value={ALERT_3IN7}>{ALERT_3IN7}</option>
                        </Form.Select>
                      </td>
                    </tr>
                    <tr>
                      <td className="left">{DIASTOLIC}</td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="dia-upper"
                            value={gdm!.diaUpper}
                            // onChange={(e) => {
                            //   setDiaUpper(e.target.value);
                            //   context.patient.diaUpper = e.target.value;
                            // }}
                            disabled
                          />
                          <InputGroup.Text id="basic-addon1">mmHg </InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <InputGroup>
                          <Form.Control
                            id="dia-lower"
                            value={gdm!.diaLower}
                            // onChange={(e) => {
                            //   setDiaLower(e.target.value);
                            //   context.patient.diaLower = e.target.value;
                            // }}
                            disabled
                          />
                          <InputGroup.Text id="basic-addon1">mmHg </InputGroup.Text>
                        </InputGroup>
                      </td>
                      <td>
                        <Form.Select
                          id="diaRuleId"
                          value={gdm!.diaRule}
                          // onChange={(e) => {
                          //   setDiaRule(e.target.value);
                          //   context.patient.diaRule = e.target.value;
                          // }}
                          disabled
                          >
                          <option value=""></option>
                          <option value={ALERT_EVERY}>{ALERT_EVERY}</option>
                          <option value={ALERT_3READINGS}>{ALERT_3READINGS}</option>
                          <option value={ALERT_MISSING}>{ALERT_MISSING}</option>
                          <option value={ALERT_3IN7}>{ALERT_3IN7}</option>
                        </Form.Select>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
    );
  }

  return (
    <></>
  )
};

export default AlertSettings;